import { JourneyAlias, ProductType } from '@hc-frontend/core-types';
import {
  PlateName,
  WhenYouNeedMedicareCoverage,
} from '@hc-frontend/features-leads';
import { z, type ZodFormattedError } from 'zod';

export const INPUT_NAME = 'whenYouNeedMedicareCoverage';

export const FormFields = z.object({
  [INPUT_NAME]: WhenYouNeedMedicareCoverage,
  product: ProductType,
  journeyAlias: JourneyAlias,
});
export type FormFields = z.infer<typeof FormFields>;
export type FormState = ZodFormattedError<FormFields>;

export const plateName = PlateName.enum.COVERAGE_URGENCY;

export const WHEN_YOU_NEED_COVERAGE_QUESTION =
  'when_you_need_medicare_coverage';
